import React, { useState } from "react";
import PasswordInput from "./PasswordInput";

export default function LoginPage({ auth }) {
  const [mode, setMode] = useState("login");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [expiredAccess, setExpiredAccess] = useState(null); // { contactName, contactEmail, expiredAt }
  const [loading, setLoading] = useState(false);

  const clearForm = () => {
    setUsername("");
    setEmail("");
    setPhoneNumber("");
    setPassword("");
    setError("");
    setExpiredAccess(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      if (mode === "register") {
        await auth.register(username, email, password, phoneNumber);
      } else {
        await auth.login(username, password);
      }
    } catch (err) {
      const data = err.response?.data;
      if (data?.code === "TEMPORARY_ACCESS_EXPIRED") {
        setExpiredAccess({
          contactName: data.contactName,
          contactEmail: data.contactEmail,
          expiredAt: data.expiredAt,
        });
      } else {
        setError(data?.error || err.message || "Authentication failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="wrapper__root__page"
      style={{ backgroundImage: `url(/login_bg.svg)` }}>
      <div className="login-card wrapper__login__card">
        <div className="login__card__inner d-flex flex-column mb__32 gap__12">
          <div className="login__logo__col pos__rel in-flex align-items-center justify-content-center">
            <img
              src="/saffronos.png"
              alt="SaffronOS Logo"
              style={{
                height: "46px",
                width: "auto",
                filter:
                  "brightness(1.12) drop-shadow(0 0 10px rgba(6,182,212,0.2))",
              }}
            />
            <span className="betaTag">
              Beta
            </span>
          </div>

          <div className="login-ai-badge">Organic search with AI, GEO etc.</div>

          <div className="text__center">
            <h1
              style={{
                fontSize: "28px",
                fontWeight: "800",
                color: "var(--text-heading)",
                letterSpacing: "-0.025em",
                lineHeight: "1.2",
                marginBottom: "8px",
              }}
              hidden
            >
              Agentic SEO
            </h1>
            <p className="fb__14 fc__5F636A">
              {mode === "register"
                ? "Create your account"
                : "Sign in to your workspace"}
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="login__form">
          {expiredAccess && (
            <div
              style={{
                marginBottom: "20px",
                padding: "16px",
                background: "rgba(245,158,11,0.08)",
                border: "1px solid rgba(245,158,11,0.3)",
                borderRadius: "12px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "8px",
                }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle
                    cx="8"
                    cy="8"
                    r="7"
                    stroke="#f59e0b"
                    strokeWidth="1.4"
                  />
                  <line
                    x1="8"
                    y1="5"
                    x2="8"
                    y2="8.5"
                    stroke="#f59e0b"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <circle cx="8" cy="11" r="0.8" fill="#f59e0b" />
                </svg>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    color: "#f59e0b",
                  }}
                >
                  Temporary access expired
                </span>
              </div>
              <p
                style={{
                  fontSize: "13px",
                  color: "var(--text-secondary)",
                  margin: "0 0 10px",
                  lineHeight: "1.5",
                }}
              >
                Your access to the system expired on{" "}
                <strong style={{ color: "var(--text-primary)" }}>
                  {new Date(expiredAccess.expiredAt).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    },
                  )}
                </strong>
                {`. Please contact ${expiredAccess.contactEmail} to extend
                your access.`}
              </p>
              {/* {expiredAccess.contactEmail ? (
                <a
                  href={`mailto:${expiredAccess.contactEmail}?subject=Access%20Extension%20Request&body=Hi%2C%0A%0AMy%20temporary%20access%20to%20SaffronOS%20has%20expired.%20Could%20you%20please%20extend%20it%3F%0A%0AUsername%3A%20${encodeURIComponent(username)}%0A%0AThank%20you.`}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#f59e0b",
                    textDecoration: "none",
                    padding: "7px 14px",
                    background: "rgba(245,158,11,0.12)",
                    border: "1px solid rgba(245,158,11,0.3)",
                    borderRadius: "8px",
                  }}
                >
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <rect
                      x="1"
                      y="2.5"
                      width="11"
                      height="8"
                      rx="1.5"
                      stroke="currentColor"
                      strokeWidth="1.3"
                    />
                    <path
                      d="M1 4l5.5 3.5L12 4"
                      stroke="currentColor"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                    />
                  </svg>
                  Email {expiredAccess.contactName || "your administrator"}
                </a>
              ) : (
                <p
                  style={{
                    fontSize: "12px",
                    color: "var(--text-muted)",
                    margin: 0,
                  }}
                >
                  Contact your administrator to restore access.
                </p>
              )} */}
            </div>
          )}

          {error && (
            <div className="alert alert-error">
              <span>⚠</span> {error}
            </div>
          )}

          <div className="form-group">
            <label>
              {mode === "register" ? "Username" : "Email / Username"}
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => {
                if (error) setError("");
                setUsername(e.target.value);
              }}
              placeholder={
                mode === "register"
                  ? "Enter your username"
                  : "Enter your email or username"
              }
              disabled={loading}
              autoFocus
            />
          </div>

          {mode === "register" && (
            <>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => {
                    if (error) setError("");
                    setEmail(e.target.value);
                  }}
                  placeholder="Enter your email"
                  disabled={loading}
                />
              </div>
              <div className="form-group">
                <label>Phone number</label>
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Optional"
                  disabled={loading}
                />
              </div>
            </>
          )}

          <div className="form-group">
            <label>Password</label>
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="common__btn common__org__btn w__100"
            disabled={loading}
            
          >
            {loading ? (
              <>
                <span
                  className="spinner"
                  style={{ width: "16px", height: "16px", borderWidth: "2px" }}
                ></span>
                {mode === "register" ? "Creating account..." : "Signing in..."}
              </>
            ) : mode === "register" ? (
              "Create account →"
            ) : (
              "Sign In →"
            )}
          </button>
        </form>

        {/* <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            color: "var(--text-secondary)",
            fontSize: "13px",
          }}
        >
          {mode === "register" ? (
            <>
              Already have an account?{" "}
              <button
                type="button"
                className="link-button"
                onClick={() => {
                  clearForm();
                  setMode("login");
                }}
              >
                Sign in
              </button>
            </>
          ) : (
            <>
              New here?{" "}
              <button
                type="button"
                className="link-button"
                onClick={() => {
                  clearForm();
                  setMode("register");
                }}
              >
                Create account
              </button>
            </>
          )}
        </div> */}

        <p
          style={{
            textAlign: "center",
            marginTop: "24px",
            fontSize: "11px",
            color: "var(--text-muted)",
            letterSpacing: "0.01em",
          }}
        >
          Secured · Encrypted · AI-Powered
        </p>
      </div>

      {/* ── Page-level footer ── */}
      <div className="login__footer">
        <span>
          © {new Date().getFullYear()} SaffronOS. All rights reserved.
        </span>
        <span style={{ opacity: 0.35 }}>·</span>
        <a
          href="/saffronos-terms.html"
          target="_blank"
          rel="noopener noreferrer"
          className="fb__11 fc__FDFCFA"
        >
          Terms of Service
        </a>
        <span style={{ opacity: 0.35 }}>·</span>
        <a
          href="/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer"
          className="fb__12 fc__FDFCFA"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  );
}
